import { apiS3FileIdToUrl } from 'api/s3File/apiS3FileIdToUrl';
import type { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { Button } from 'components/Button/Button';
import { Icon } from 'components/Icon/Icon';
import { useI18n } from 'i18n/hooks/useI18n';
import { dateTime } from 'utils/date';

import {
  LargeFilePickerFilenameBody,
  LargeFilePickerFilenameLastUpdated,
  LargeFilePickerFilenameLink,
  LargeFilePickerFilenameText,
} from './LargeFilePickerFilename.styled';

type Props = {
  fileId: string;
  qaId: string;
  downloadAttachment: boolean;
  filename: string | null;
  onRemove: (() => void) | null;
  created: ApiISODateTimeString | null;
  disabled: boolean;
};

export function LargeFilePickerFilename({
  fileId,
  qaId,
  downloadAttachment,
  filename,
  onRemove,
  created,
  disabled,
}: Props) {
  const { i18n, locale } = useI18n();

  return (
    <div>
      <LargeFilePickerFilenameBody data-qa-id={`${qaId}-preview`}>
        <LargeFilePickerFilenameLink
          title={
            downloadAttachment ? i18n('Download') : i18n('Open in new window')
          }
          href={apiS3FileIdToUrl({ fileId, downloadAttachment })}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation();
          }}
          rel="noopener noreferrer"
        >
          <LargeFilePickerFilenameText>{filename}</LargeFilePickerFilenameText>
        </LargeFilePickerFilenameLink>

        {onRemove && !disabled && (
          <Button
            type="button"
            variant="link-danger"
            noPadding
            title={
              /* TRANSLATORS: Remove file upload */
              i18n('Remove file %(filename)s', { filename: filename ?? '' })
            }
            qaId={`${qaId}-delete`}
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          >
            <Icon name="close" size={16} />
          </Button>
        )}
      </LargeFilePickerFilenameBody>

      {created && (
        <LargeFilePickerFilenameLastUpdated data-qa-id={`${qaId}-upload-date`}>
          {i18n('Last updated: %(date)s', {
            date: dateTime({ date: created, locale }),
          })}
        </LargeFilePickerFilenameLastUpdated>
      )}
    </div>
  );
}
